.overlay {
  background-color: rgba(0, 0, 0, .8);
  position: absolute;
  display: flex;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  justify-content: center;
}

.center {
  align-items: center;
  display: flex;
}

.message {
  margin: 5px;
  padding: 60px;
  font-size: 18px;
  text-align: center;
  color: white;
}

.learnMore {
  color: white;
  display: flex;
  justify-content: center;
}

.upgradeBtn {
  margin-top: 10px;
  background-color: #5EA0E8;
  text-align: center;
  color: white;
  font-size: 14px;
  font-weight: normal;
  line-height: 25px;
  width: 100px;
  height: 28px;
  border: 1px solid #979797;
  cursor: pointer;
}